<footer class="footer">
    <mat-toolbar>
      <a [routerLinkActiveOptions]="{ exact: true }" 
              [routerLinkActive]="['link-active']"
              [routerLink]="['/adv-create']" 
              class="footer__btPremium btn" 
              mat-raised-button 
              color="primary">
          <mat-icon aria-hidden="false" aria-label="premium button">post_add</mat-icon>
          Submit Ad
      </a>
      <!-- <a class="footer__btSearch btn" mat-button color="primary" [routerLink]="['/search']"><mat-icon aria-hidden="false" aria-label="search button">search</mat-icon>Search</a> -->

      <a class="footer__btHome btn" mat-button color="primary" [routerLink]="['/']"><mat-icon aria-hidden="false" aria-label="home button">home</mat-icon></a>
      
      <a *ngIf="mainService.userService.isAuthenticated()" class="footer__btAccount btn" mat-raised-button color="primary" [routerLink]="['/account']"><mat-icon aria-hidden="false" aria-label="account button">account_box</mat-icon>Account</a>
    
      <a [routerLink]="['/login']"
      *ngIf="!mainService.userService.isAuthenticated()"
      class="appNav__btnsignIn"
      mat-raised-button 
      color="primary">
        Sign In
      </a>

    </mat-toolbar>
  </footer>